const filtersMappers = {
  stores: (stores) => (stores?.length > 0 ? `&store_ids=[${stores.map((store) => store.id).join(',')}]` : ''),
  dispatchMethods: (dispatchMethods) =>
    dispatchMethods?.length > 0 ? `&dispatch_method=[${dispatchMethods.join(',')}]` : '',
  orderAge: (age) => (age ? `&order_age=${age}` : ''),
  orderId: (id) => (id ? `&order_id=${id}` : '')
};

export const mapFilters = (filters, orderStatus) => {
  let mappedFilters = Object.entries(filters)
    .map(([key, value]) => filtersMappers[key](value))
    .join('');

  if (orderStatus) {
    mappedFilters += `&status=[${orderStatus.map((status) => status).join(',')}]`;
  }

  return mappedFilters;
};
